import Layout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import PensionUserListContainer from '../containers/PensionUser/PensionUserList.container'

const PensionUser = () => {
  return (
    <Layout
      header={<HeaderContainer />}
      sidebar={<SidebarContainer />}
    >
      <PensionUserListContainer />
    </Layout>
  )
}

export default PensionUser
